import { render, staticRenderFns } from "./JourneyBrickCircle.vue?vue&type=template&id=bc4c9f88&scoped=true&"
import script from "./JourneyBrickCircle.vue?vue&type=script&lang=js&"
export * from "./JourneyBrickCircle.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-brick-circle.scss?vue&type=style&index=0&id=bc4c9f88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c9f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc4c9f88')) {
      api.createRecord('bc4c9f88', component.options)
    } else {
      api.reload('bc4c9f88', component.options)
    }
    module.hot.accept("./JourneyBrickCircle.vue?vue&type=template&id=bc4c9f88&scoped=true&", function () {
      api.rerender('bc4c9f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBrickCircle.vue"
export default component.exports